import { Checkbox, createTheme, FormControlLabel, makeStyles, ThemeProvider } from '@material-ui/core';
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router-dom";
import '../../shared/components/styles/Navigation.css';
function NavigationCheck({setBusqueda, state}) {
    //let history = useHistory();
  const handleChangeCentro = ( { target } ) => {
      setBusqueda({
        investigador:false,
        centro: target.checked 
      })
  }

  const handleChangeInvestigador = ( { target } ) => {
      setBusqueda({
        investigador:target.checked,
        centro: false
      })
  };


  const theme = createTheme({
    palette: {
      primary: {
        main: '#0062a1',
      }
    },
  });

  const useStyles = makeStyles({
    label: {
      color: 'var(--primary)',
      fontWeight: 'bold',
      fontSize: '14px'
    },
    checked:{
      color: 'var(--primary)!important',
    }
    
  });
  const classes = useStyles();
  return (
    
    <div className="navigation">
      <ThemeProvider theme={theme}>
        
        <FormControlLabel
            classes={ { label: classes.label } }
            label="Investigadores"
            labelPlacement="end"
            control={
              <Checkbox
                classes={ { checked: classes.checked } }
                checked={state.investigador} 
                onChange={ handleChangeInvestigador}
                name="investigador"
              />
            }
        />

        <FormControlLabel
          classes={ { label: classes.label } }
          label="Centros"
          labelPlacement="end"
          control={
            <Checkbox
              classes={ { checked: classes.checked } }
              checked={state.centro} 
              onChange={handleChangeCentro} 
              name="centro" 
            />
          }
        />

      </ThemeProvider>
      
    </div>
  );
}

NavigationCheck.prototype = {
  setBusqueda: PropTypes.func.isRequired,
  state: PropTypes.object.isRequired
}

export default withRouter(NavigationCheck);
